/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.SelfCheckInKiosk {

    class EnhancementRow implements ng.IComponentController {
        enhancement: IAddOnService & IHasPriorVisitAtLocation & { disabled?: boolean, selected?: boolean };

        onClick() {
            if (this.enhancement.disabled) {
                return;
            }

            this.enhancement.selected = !this.enhancement.selected;
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .component('scikEnhancementRow', <ng.IComponentOptions>{
            templateUrl: 'app/plugins/selfCheckInKiosk/components/enhancement/enhancement.component.html',
            controller: EnhancementRow,
            bindings: {
                enhancement: '<'
            }
        });
}
